import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AdminBaseListComponent } from 'src/modules/sm-base/components/admin-base-list/admin-base-list.component';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { TableCellType } from 'src/modules/sm-base/netgen/TableCellType';
import { TableColumn } from 'src/modules/sm-base/netgen/TableColumn';
import { Objects } from "src/modules/utils/shared/objects";
import { ProjectPlanningTools } from "../../models/project-planning-tools.model";
import { CalendarOutlineLevel } from '../../netgen/CalendarOutlineLevel';

@Component({
    selector: 'app-edit-calendar-outline-level',
    templateUrl: '../../../sm-base/components/admin-base-list/admin-base-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditCalendarOutlineLevelsComponent extends AdminBaseListComponent<CalendarOutlineLevel> {

    definition = ProjectPlanningTools.definitionCalendarOutlineLevel;

    getTable(): TableData {
        return this.app.tTable("entity.CalendarOutlineLevel.fields", new TableData([
            new TableColumn("title", "", TableCellType.string, 50)
        ], this.listData.map(o => new TableRow(Objects.toString(o.id), o, {
            title: o.title
        })), ["title"]));
    }

}
